module.exports = __webpack_public_path__ + "assets/img/free.12fb946d.png";